import React from "react";
import { Route, Routes } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { Box } from "@mui/material";
import Login from "../pages/Login";
import Signup from "../pages/Signup";
import Dashboard from "../pages/Dashboard";
import WorksegmentList from "../pages/Worksegments";
import Schedule from "../pages/Schedule";
import Projects from "../pages/Projects";
import Announcements from "../pages/Announcements";
import Expenses from "../pages/Expenses";
import Profile from "../pages/Profile";
import Task from "../pages/Task";
import Field from "../pages/Field";
import Shop from "../pages/Shop";
import Door from "../pages/Door";
import Engineering from "../pages/Engineering";
import Reports from "../pages/Reports";
import Videos from "../pages/Videos";
import Settings from "../pages/Settings";
import ProjectTask from "../pages/ProjectTask";
import Holidays from "../pages/Holidays";
import WorkOrders from "../pages/WorkOrders";
import Waveguides from "../pages/Waveguides";
import Doors from "../pages/Doors";
import Windows from "../pages/Windows";
import Panels from "../pages/Panels";
import QRCodeWorkOrderScan from "../pages/QRCodeWorkOrderScan";

function MainRoutes(props) {
    const {
        user,
        token,
        setToken,
        login,
        signup,
        loginErrors,
        darkState,
        handleOpenSnackbar,
    } = props;
    const { worksegments, setWorksegments } = props;
    const { totals, setTotals } = props;
    const { isoWeek, setIsoWeek } = props;
    const { PTOsegments, setPTOsegments } = props;
    const { employees } = props;
    const { handleChangeMode } = props;

    return (
        <div>
            <Routes>
                <Route
                    exact
                    path="/"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Dashboard
                                user={user}
                                token={token}
                                setToken={setToken}
                                handleOpenSnackbar={handleOpenSnackbar}
                                worksegments={worksegments}
                                setWorksegments={setWorksegments}
                                PTOsegments={PTOsegments}
                                setPTOsegments={setPTOsegments}
                                totals={totals}
                                setTotals={setTotals}
                                isoWeek={isoWeek}
                                setIsoWeek={setIsoWeek}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/worksegments"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <WorksegmentList
                                user={user}
                                token={token}
                                handleOpenSnackbar={handleOpenSnackbar}
                                darkState={darkState}
                                worksegments={worksegments}
                                setWorksegments={setWorksegments}
                                PTOsegments={PTOsegments}
                                setPTOsegments={setPTOsegments}
                                totals={totals}
                                setTotals={setTotals}
                                isoWeek={isoWeek}
                                setIsoWeek={setIsoWeek}
                                employees={employees}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/schedule"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Schedule user={user} token={token} />
                        )
                    }
                />
                <Route
                    exact
                    path="/projects"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Projects
                                user={user}
                                token={token}
                                darkState={darkState}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/projecttask"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <ProjectTask
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/announcements"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Announcements
                                user={user}
                                token={token}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/holidays"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Holidays
                                user={user}
                                token={token}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/expenses"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Expenses
                                user={user}
                                token={token}
                                handleOpenSnackbar={handleOpenSnackbar}
                                employees={employees}
                                darkState={darkState}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/task"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Task
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                                employees={employees}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/field"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Field
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                                employees={employees}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/shop"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Shop
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/engineering"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Engineering
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/reports"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Reports
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                                employees={employees}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/profile"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Profile
                                darkState={darkState}
                                user={user}
                                token={token}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/settings"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Settings
                                user={user}
                                token={token}
                                darkState={darkState}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/login"
                    element={
                        user.username ? (
                            <Navigate to="/" />
                        ) : (
                            <Login
                                login={login}
                                errors={loginErrors}
                                darkState={darkState}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/signup"
                    element={<Signup signup={signup} darkState={darkState} />}
                />
                <Route
                    exact
                    path="/videos"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Videos
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/asset/door/:id"
                    element={
                        <Door
                            user={user}
                            token={token}
                            darkState={darkState}
                            handleOpenSnackbar={handleOpenSnackbar}
                            handleChangeMode={handleChangeMode}
                        />
                    }
                />
                <Route
                    exact
                    path="/workorders"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <WorkOrders
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/asset/waveguides"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Waveguides
                                user={user}
                                token={token}
                                darkState={darkState}
                                handleOpenSnackbar={handleOpenSnackbar}
                            />
                        )
                    }
                />
                <Route
                    exact
                    path="/asset/doors"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Box m={3}>
                                <Doors
                                    user={user}
                                    token={token}
                                    darkState={darkState}
                                    handleOpenSnackbar={handleOpenSnackbar}
                                />
                            </Box>
                        )
                    }
                />
                <Route
                    exact
                    path="/asset/windows"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Box m={3}>
                                <Windows
                                    user={user}
                                    token={token}
                                    darkState={darkState}
                                    handleOpenSnackbar={handleOpenSnackbar}
                                />
                            </Box>
                        )
                    }
                />
                <Route
                    exact
                    path="/asset/panels"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Box m={3}>
                                <Panels
                                    user={user}
                                    token={token}
                                    darkState={darkState}
                                    handleOpenSnackbar={handleOpenSnackbar}
                                />
                            </Box>
                        )
                    }
                />
                <Route
                    exact
                    path="/qr-code-scan"
                    element={
                        !user.username ? (
                            <Navigate to="/login" />
                        ) : (
                            <Box m={3}>
                                <QRCodeWorkOrderScan
                                    user={user}
                                    token={token}
                                    darkState={darkState}
                                    handleOpenSnackbar={handleOpenSnackbar}
                                />
                            </Box>
                        )
                    }
                />

                <Route render={() => <h1>Error 404</h1>} />
            </Routes>
        </div>
    );
}

export default MainRoutes;
